<template>
  <div class="target">
    <div class="conTent">
      <div class="con" @click="toUrl">
        <div class="conLeft">
          <span @click.stop="openPicker"
            >{{ currentDate }}
            <i v-if="timePicker !== true"><van-icon name="arrow-down" /></i>
            <i v-else><van-icon name="arrow-up" /></i>
          </span>
          <van-popup
            v-model="timePicker"
            round
            get-container="body"
            position="bottom"
          >
            <van-picker
              show-toolbar
              title="选择年份"
              :default-index="defaultIndex"
              :columns="columns"
              @cancel="timePicker = false"
              @confirm="confirmDate"
            />
          </van-popup>
          <p>总部职能绩效考核结果：</p>
        </div>
        <div class="conRight">
          <img src="@/assets/grade/s.svg" v-if="baseinfo.grade==='S'" alt=""/>
          <img src="@/assets/grade/a.svg" v-if="baseinfo.grade==='A'" alt=""/>
          <img src="@/assets/grade/b.svg" v-if="baseinfo.grade==='B'" alt=""/>
          <img src="@/assets/grade/c.svg" v-if="baseinfo.grade==='C'" alt=""/>
          <img src="@/assets/grade/d.svg" v-if="baseinfo.grade==='D'" alt=""/>
          <span v-if="!baseinfo.grade">暂无</span>
        </div>
      </div>
      <div class="footer">
        恭喜您在{{baseinfo.countYear}}年度绩效考核中
        <span v-if="baseinfo.grade==='S'">远超出目标</span>
        <span v-if="baseinfo.grade==='A'">超出目标</span>
        <span v-if="baseinfo.grade==='B'">达成目标</span>
        <span v-if="baseinfo.grade==='C'">部分达成目标</span>
        <span v-if="baseinfo.grade==='D'">未达成目标</span>
        <span v-if="!baseinfo.grade">暂无</span>
        ，请继续保持努力，“光随心行，智亮未来”，未来的日子，任重道远，愿我们不负当下，不惧未来，再创佳绩！
      </div>
    </div>
  </div>
</template>

<script>

import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "target",
  data() {
    return {
      currentDate: moment().add(-1,'y').format("YYYY") + "年", // 当前展示时间
      timePicker: false,
      columns: [], //
      defaultIndex: 0,
      baseinfo:{}
    };
  },
  props:['createdate'],
  mounted(){
    this.getList()
    setTimeout(()=>{
      this.initYear()
    },600)
  },
  methods: {
    //获取年份
    initYear(){
      const lastYear = moment(new Date()).year();
      const createdate =  moment(this.createdate).year()
      let outYear = lastYear - createdate + 1
      this.columns = [...new Array(outYear).keys()]
        .map((k) => {
          return `${lastYear - k}年`;
        })
        .reverse();
    },
    // 选择年份
    openPicker() {
      const currentIndex = this.columns.findIndex((item) => {
        return item === (this.currentDate || `${moment().year()}年`);
      });
      this.defaultIndex = currentIndex > -1 ? currentIndex : 0;
      this.timePicker = true;
    },
    // 回调参数: 多列：所有列选中值，所有列选中值对应的索引
    confirmDate(value) {
      this.currentDate = value;
      this.timePicker = false;
      this.getList()
    },
    //跳转详情
    toUrl(){
      this.$router.push({
        path:'/mobile/diligence/detail',
        query:{
          time:parseInt(this.currentDate),
          createdate:this.createdate
        }
      })
    },
    //获取个人信息
    getList(){
      const time = parseInt(this.currentDate)
      api.selectSingleKpiDetail({empNo:getToken(),searchYear:time}).then((data)=>{
        console.log(data);
        this.baseinfo = data.data
      })
    }
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.target {
  font-size: 16px * $zoom;
  .conTent {
    width: 100%;
    background: #fff;
    padding: 10px * $zoom 10px * $zoom;
    border-radius: 10px * $zoom;
    .con {
      height: 100px * $zoom;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .conLeft {
        span {
          padding: 7px 18px;
          font-size: 12pt;
          color: #018755;
          border: 1px solid #018755;
          border-radius: 15px * $zoom;
        }
        p {
          font-size: 12pt;
          margin-top: 12px * $zoom;
        }
      }
      .conRight{
        img{
          width: 116pt;
          height: 116pt;
        }
      }
    }
    .footer {
      width: 100%;
      background: #eeeeee;
      border-radius: 5px * $zoom;
      padding: 10px * $zoom;
      font-size: 10pt;
      line-height: 17px * $zoom;
      text-indent:2em;
    }
  }
}
</style>
